(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uh-compare"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uh-room-table')) {
    class UhRoomTable extends HTMLElement {
      connectedCallback() {
        try { this.cols = JSON.parse(this.dataset.cols).filter((c) => c.cadr).sort((a, b) => a.cadr - b.cadr); } catch (e) { this.cols = []; }
        this.onRoom = (e) => this.render(e.detail);
        document.addEventListener('uh:room', this.onRoom);
        const sqft = +this.dataset.sqft || 200, h = +this.dataset.ceiling || 9;
        this.render({ label: this.dataset.label || 'Your room', sqft, vol: sqft * h * 0.0283168 });
      }
      disconnectedCallback() { document.removeEventListener('uh:room', this.onRoom); }
      render(r) {
        const ach = (c) => c.cadr / r.vol;
        const tag = (a) => a >= 4.8 ? '<span class="uh-tag uh-tag--ok">Enough</span>' : a >= 3.5 ? '<span class="uh-tag uh-tag--mid">Not quite</span>' : '<span class="uh-tag uh-tag--low">Too small</span>';
        this.querySelector('[data-room]').textContent = `${r.label} (about ${r.sqft} sq ft)`;
        const rows = this.cols.slice().sort((a, b) => b.cadr - a.cadr).map((c) => {
          const a = ach(c), w = Math.min(100, a / 10 * 100);
          return `<li class="uh-fit__row${c.us ? ' uh-fit__row--us' : ''}"><span class="uh-fit__name">${c.name}<small>Clean air: ${c.cadr} m³/h</small></span><span class="uh-fit__bar"><b style="width:${w}%"></b><i></i></span><span class="uh-fit__val">Cleans it ${a.toFixed(1)} times an hour ${tag(a)}</span></li>`;
        });
        this.querySelector('[data-body]').innerHTML = rows.join('');
      }
    }
    customElements.define('uh-room-table', UhRoomTable);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uh-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uh-exploded')) {
    class UhExploded extends HTMLElement {
      connectedCallback() {
        const svg = this.querySelector('svg');
        if (!svg || svg.childElementCount) return;
        const NS = 'http://www.w3.org/2000/svg', INK = '#14171A', STEEL = '#6B747C', SIG = '#FF4F12', SHEET = '#F6F7F8';
        const el = (t, a, p) => { const e = document.createElementNS(NS, t); for (const k in a) e.setAttribute(k, a[k]); if (p) p.appendChild(e); return e; };
        const txt = (p, x, y, s, o) => { const t = el('text', Object.assign({ x, y, 'font-family': 'IBM Plex Mono, monospace', 'font-size': 11, fill: STEEL }, o || {}), p); t.textContent = s; return t; };
        const id = 'uhx' + Math.random().toString(36).slice(2, 7);
        const d = el('defs', {}, svg);
        const ao = el('marker', { id: id + 'a', viewBox: '0 0 10 10', refX: 9, refY: 5, markerWidth: 6, markerHeight: 6, orient: 'auto' }, d); el('path', { d: 'M0 0L10 5L0 10Z', fill: SIG }, ao);
        const m = el('pattern', { id: id + 'm', width: 6, height: 6, patternUnits: 'userSpaceOnUse' }, d); el('rect', { width: 6, height: 6, fill: SHEET }, m); el('path', { d: 'M0 6L6 0M0 0L6 6', stroke: STEEL, 'stroke-width': .6 }, m);
        const c = el('pattern', { id: id + 'c', width: 5, height: 5, patternUnits: 'userSpaceOnUse' }, d); el('rect', { width: 5, height: 5, fill: '#2B2F33' }, c); el('circle', { cx: 1.5, cy: 1.5, r: .9, fill: '#4A5056' }, c);
        const dm = el('pattern', { id: id + 'd', width: 10, height: 10, patternUnits: 'userSpaceOnUse' }, d); el('rect', { width: 10, height: 10, fill: SHEET }, dm); el('path', { d: 'M5 1L9 5L5 9L1 5Z', fill: 'none', stroke: INK, 'stroke-width': .8 }, dm);
        const labels = (this.dataset.labels || '').split('|').map((s) => s.split(':'));
        const ox = .9, oy = -.32, W = 170, H = 300, depth = [16, 10, 22, 14, 60], gap = 118, x0 = 40, y0 = 200;
        const fills = [`url(#${id}d)`, `url(#${id}m)`, SHEET, `url(#${id}c)`, SHEET];
        const call = el('g', { class: 'uh-ex-call' });
        for (let i = 4; i >= 0; i--) {
          const x = x0 + i * gap * ox, y = y0 + i * gap * oy, dd = depth[i], dx = dd * ox, dy = dd * oy;
          const g = el('g', { class: 'uh-ex-layer' }, svg);
          g.style.setProperty('--dx', ((4 - i) * gap * ox * .85) + 'px'); g.style.setProperty('--dy', ((4 - i) * gap * oy * .85) + 'px');
          el('path', { d: `M${x} ${y}L${x + W} ${y}L${x + W + dx} ${y + dy}L${x + dx} ${y + dy}Z`, fill: '#D9DEE2', stroke: INK, 'stroke-width': 1.1 }, g);
          el('path', { d: `M${x + W} ${y}L${x + W + dx} ${y + dy}L${x + W + dx} ${y + H + dy}L${x + W} ${y + H}Z`, fill: '#C9CFD4', stroke: INK, 'stroke-width': 1.1 }, g);
          el('rect', { x, y, width: W, height: H, fill: fills[i], stroke: INK, 'stroke-width': 1.3 }, g);
          if (i === 2) for (let k = 1; k < 30; k++) el('line', { x1: x + k * W / 30, y1: y + 6, x2: x + k * W / 30, y2: y + H - 6, stroke: STEEL, 'stroke-width': .8 }, g);
          if (i === 4) { el('circle', { cx: x + W / 2, cy: y + H / 2 + 10, r: 62, fill: 'none', stroke: INK, 'stroke-width': 1.2 }, g); for (let b = 0; b < 12; b++) { const an = b / 12 * Math.PI * 2; el('line', { x1: x + W / 2 + Math.cos(an) * 14, y1: y + H / 2 + 10 + Math.sin(an) * 14, x2: x + W / 2 + Math.cos(an + .5) * 58, y2: y + H / 2 + 10 + Math.sin(an + .5) * 58, stroke: STEEL, 'stroke-width': 1.2 }, g); } el('rect', { x, y, width: W, height: 28, fill: '#23272B' }, g); }
          const lb = labels[i] || ['', ''], num = (i >= 1 && i <= 3) ? String(i) : '';
          const lx = x + W / 2, ty = y - 26 - [0, 62, 0, 62, 96][i];
          el('line', { x1: lx, y1: y + 4, x2: lx, y2: ty + 6, stroke: INK, 'stroke-width': .7 }, call); el('circle', { cx: lx, cy: y + 4, r: 2.4, fill: INK }, call);
          if (num) txt(call, lx - 4, ty, num, { fill: SIG, 'text-anchor': 'end' });
          txt(call, lx + (num ? 2 : -30), ty, (lb[0] || '').toUpperCase(), { fill: INK, 'font-family': 'Archivo, sans-serif', 'font-weight': 700 });
          txt(call, lx + (num ? 2 : -30), ty + 13, lb[1] || '', { 'font-size': 9.5 });
        }
        svg.appendChild(call);
        for (let a = 0; a < 3; a++) { const yy = y0 + 90 + a * 60; el('line', { x1: 2, y1: yy, x2: x0 - 6, y2: yy, stroke: SIG, 'stroke-width': 2, 'marker-end': `url(#${id}a)` }, call); }
        txt(call, 4, y0 + H + 30, this.dataset.in || '', { fill: SIG, 'font-size': 10 });
        const bx = x0 + 4 * gap * ox, by = y0 + 4 * gap * oy;
        for (let k = 0; k < 3; k++) el('line', { x1: bx + 40 + k * 45, y1: by - 8, x2: bx + 40 + k * 45, y2: by - 40, stroke: SIG, 'stroke-width': 2, 'marker-end': `url(#${id}a)` }, call);
        txt(call, bx + 85, by - 48, this.dataset.out || '', { fill: SIG, 'font-size': 10, 'text-anchor': 'middle' });
      }
    }
    customElements.define('uh-exploded', UhExploded);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uh-learn"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uh-tabs')) {
    class UhTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll(':scope > [role=tablist] > [role=tab]')];
        this.panels = [...this.querySelectorAll(':scope > [role=tabpanel]')];
        this.classList.add('is-ready');
        this.tabs.forEach((t, i) => {
          t.addEventListener('click', () => this.select(i));
          t.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); this.select((i + 1) % this.tabs.length, true); } if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); this.select((i - 1 + this.tabs.length) % this.tabs.length, true); } });
        });
        this.select(Math.max(0, this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true')));
        document.addEventListener('shopify:block:select', (e) => { const i = this.panels.findIndex((p) => p.contains(e.target) || p === e.target); if (i > -1) this.select(i); });
      }
      select(i, focus) {
        this.tabs.forEach((t, j) => { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); t.tabIndex = j === i ? 0 : -1; });
        this.panels.forEach((p, j) => { p.hidden = j !== i; });
        if (focus) this.tabs[i].focus();
      }
    }
    customElements.define('uh-tabs', UhTabs);
  }
  if (!customElements.get('uh-sqft')) {
    class UhSqft extends HTMLElement {
      connectedCallback() {
        this.rates = [[0.5, 'once every 2 hours'], [1, 'once an hour'], [2, 'twice an hour'], [3, '3 times an hour'], [4, '4 times an hour'], [4.8, 'about 5 times an hour'], [6, '6 times an hour']];
        this.btns = [...this.querySelectorAll('[data-cadr]')];
        this.input = this.querySelector('input[type=range]');
        this.cadr = +(this.btns[0]?.dataset.cadr || 390);
        this.btns.forEach((b) => b.addEventListener('click', () => { this.cadr = +b.dataset.cadr; this.btns.forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false')); this.render(); }));
        this.input?.addEventListener('input', () => this.render());
        this.render();
      }
      render() {
        const r = this.rates[+this.input.value], sq = (c, rate) => c * 0.91 * 4.8 / rate, a = sq(this.cadr, r[0]), real = sq(this.cadr, 4.8);
        const fmt = (v, s) => (Math.round(v / s) * s).toLocaleString('en-IN') + ' sq ft';
        this.querySelector('[data-rate]').textContent = r[1];
        this.querySelector('[data-area]').textContent = fmt(a, 10);
        this.querySelector('[data-real]').textContent = fmt(real, 5);
        const mins = Math.round(60 / r[0]);
        this.querySelector('[data-areas]').textContent = 'The air in that room gets cleaned once every ' + (mins >= 120 ? '2 hours' : mins === 60 ? 'hour' : mins + ' minutes');
        this.querySelector('[data-say]').textContent = r[0] < 4.8 ? 'Same machine, same clean air per hour. At this rate the room size looks ' + (Math.round(a / real * 10) / 10) + ' times bigger, but in a room that big the PM2.5 would barely come down.' : 'At about 5 cleans an hour, this purifier keeps a room of ' + fmt(real, 5) + ' clean through a high-AQI day.';
      }
    }
    customElements.define('uh-sqft', UhSqft);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uh-room-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uh-rooms')) {
    class UhRooms extends HTMLElement {
      connectedCallback() {
        this.opts = [...this.querySelectorAll('.uh-rooms__opt')];
        this.res = [...this.querySelectorAll('[data-res]')];
        this.target = parseFloat(this.dataset.target) || 4.8;
        this.ceiling = parseFloat(this.dataset.ceiling) || 9;
        this.opts.forEach((o) => o.addEventListener('click', () => this.select(+o.dataset.i, true)));
        this.querySelector('[data-exact-go]')?.addEventListener('click', () => this.exact());
        const start = this.opts.find((o) => o.getAttribute('aria-checked') === 'true') || this.opts[0];
        if (start) this.select(+start.dataset.i, false);
        document.addEventListener('shopify:block:select', (e) => { const o = e.target.closest?.('.uh-rooms__opt'); if (o && this.contains(o)) this.select(+o.dataset.i, false); });
      }
      select(i, scroll) {
        this.opts.forEach((o) => o.setAttribute('aria-checked', +o.dataset.i === i ? 'true' : 'false'));
        this.res.forEach((r) => { r.hidden = +r.dataset.res !== i; });
        const o = this.opts.find((x) => +x.dataset.i === i); if (!o) return;
        const sqft = +o.dataset.sqft || 0;
        document.dispatchEvent(new CustomEvent('uh:room', { detail: { label: o.dataset.label, sqft, vol: sqft * this.ceiling * 0.0283168 } }));
        if (scroll && window.matchMedia('(max-width: 860px)').matches) this.res.find((r) => +r.dataset.res === i)?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      exact() {
        const l = +this.querySelector('[data-exact="l"]').value, w = +this.querySelector('[data-exact="w"]').value;
        const msg = this.querySelector('[data-exact-msg]');
        if (!l || !w) { msg.textContent = 'Enter both length and width in feet.'; return; }
        const area = l * w, vol = area * this.ceiling * 0.0283168;
        const fits = this.opts.map((o) => ({ i: +o.dataset.i, cadr: +o.dataset.cadr, sqft: +o.dataset.sqft })).filter((x) => x.cadr > 0 && x.sqft > 60).sort((a, b) => a.cadr - b.cadr);
        const pick = fits.find((x) => x.cadr / vol >= this.target) || fits[fits.length - 1];
        if (!pick) return;
        this.select(pick.i, true);
        msg.textContent = `${l} × ${w} ft = ${area} sq ft. The pick above cleans it ${(pick.cadr / vol).toFixed(1)} times an hour.`;
      }
    }
    customElements.define('uh-rooms', UhRooms);
  }

  } catch(e) { console.error(e); }
})();
})();
